import React from 'react';
import { Typography, Paper, Box, Button } from '@mui/material';
import { Payment, Settings } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from '@contexts/AuthContext';

export default function ReceptionPayments() {
  const { user } = useAuth();
  const isClinicAdmin = user?.role === 'clinic_admin';

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>Plăți</Typography>
      <Paper sx={{ p: 4 }}>
        <Payment sx={{ fontSize: 48, color: 'text.secondary', mb: 2 }} />
        <Typography variant="h6" color="text.secondary" gutterBottom>
          Încasări, refund, reconciliere
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Pentru a încasa o plată pe card, mergeți la <strong>Facturare</strong>, selectați factura și apăsați butonul &quot;Plată&quot; (dacă factura este legată de o vizită).
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Button component={RouterLink} to="../invoicing" variant="contained">
            Facturare
          </Button>
          {isClinicAdmin && (
            <Button component={RouterLink} to="/clinic/payment-settings" variant="outlined" startIcon={<Settings />}>
              Setări plăți (Stripe)
            </Button>
          )}
        </Box>
      </Paper>
    </Box>
  );
}
